import { useEffect, useState } from "react";
import { SkeletonBlock } from "../../components/skeletons/SkeletonBlock.jsx";
import { useThemeSlice } from "../../components/ui/StatusBadge.jsx";

const FMS_URL = "https://dev-fleet-1.intellicar.app/fms";

export function AccountFmsTab({ account }) {
  const { c } = useThemeSlice();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
  }, [account.id]);

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden", height: "100%" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          padding: "8px 14px",
          borderBottom: `1px solid ${c.divider}`,
          background: c.sb,
          flexShrink: 0,
        }}
      >
        <p style={{ margin: 0, fontSize: 12, color: c.sub }}>
          Fleet Management opens embedded. Sign in if prompted.
        </p>
        <a
          href={FMS_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: 12, fontWeight: 600, color: c.text, whiteSpace: "nowrap" }}
        >
          Open in new tab
        </a>
      </div>
      <div style={{ position: "relative", flex: 1, minHeight: 0, display: "flex" }}>
        {!loaded && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              flexDirection: "column",
              gap: 12,
              padding: 20,
              background: c.bg,
              zIndex: 1,
            }}
          >
            <SkeletonBlock height={24} width="40%" />
            <SkeletonBlock height="100%" style={{ flex: 1 }} />
          </div>
        )}
        <iframe
          key={account.id}
          title="Fleet Management System"
          src={FMS_URL}
          onLoad={() => setLoaded(true)}
          style={{ flex: 1, width: "100%", height: "100%", border: "none", minHeight: 0, display: "block" }}
          allow="fullscreen"
        />
      </div>
    </div>
  );
}
